import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  schemaData?: Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  schemaData,
}: SEOHeadProps) {
  const location = useLocation();
  const defaultTitle = 'PG征途国际下载安装-官方正版客户端一键安装指南';
  const defaultDescription = 'PG征途国际下载安装全流程指南，提供官方正版客户端安卓iOS最新版本，安全无病毒，一键下载安装即玩，支持新手礼包领取，海量玩家好评。';
  const defaultKeywords = 'PG征途国际下载安装,PG征途国际客户端,PG征途国际官方下载,征途国际手游下载,PG征途国际安卓下载,PG征途国际iOS下载,征途国际最新版下载';

  const pageTitle = title || defaultTitle;
  const pageDescription = description || defaultDescription;
  const pageKeywords = keywords || defaultKeywords;

  useEffect(() => {
    document.title = pageTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', pageDescription);
    setMeta('keywords', pageKeywords);
    setMeta('og:title', pageTitle, true);
    setMeta('og:description', pageDescription, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl || `https://pgzhengtu.com${location.pathname}`, true);
    setMeta('twitter:title', pageTitle);
    setMeta('twitter:description', pageDescription);

    const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonical) {
      canonical.href = canonicalUrl || `https://pgzhengtu.com${location.pathname}`;
    }
  }, [pageTitle, pageDescription, pageKeywords, canonicalUrl, ogType, location.pathname]);

  useEffect(() => {
    if (!schemaData) return;

    const scriptId = 'structured-data';
    let scriptEl = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!scriptEl) {
      scriptEl = document.createElement('script');
      scriptEl.id = scriptId;
      scriptEl.type = 'application/ld+json';
      document.head.appendChild(scriptEl);
    }
    scriptEl.textContent = JSON.stringify(schemaData);
  }, [schemaData]);

  return null;
}